<template>
    <base-demo-flow
        :phone_key="phone_key"
        :phone_mode="phone_mode"
        :browser_content_key="current_step"
        business_name="Barrel Creek Vineyards"
        phone_number="(555) 123-4567"
        browser_url="barrelcreek.com/shop/2024-sauvignon-blanc"
        phone_label="Sarah's Phone"
        :current_step_number="current_step_number"
        :total_steps="total_steps"
        :progress_percentage="progress_percentage"
        :current_step_name="current_step_name"
        :can_go_previous="can_go_previous"
        :can_go_next="can_go_next"
        :steps="formatted_steps"
        @restart="resetDemo"
        @previous="goToPreviousStep"
        @next="goToNextStep"
        @step-click="goToStep"
    >
        <template #explainer>
            <component
                :is="explainer_component"
                :customer_data="customer_data"
                :wine_data="wine_data"
                @reset="resetDemo"
                @reset-web-experience="resetWebExperience"
            />
        </template>

        <template #phone-messages>
            <mock-text-conversation
                :messages="conversation"
                :previously_shown_count="previously_shown_message_count"
            />
        </template>

        <template #phone-browser>
            <mock-wine-release-landing
                v-if="current_step === 'landing-page'"
                :wine_data="wine_data"
                :customer_data="customer_data"
                @chat-complete="handleChatComplete"
                @chat-handoff="handleChatHandoff"
            />
        </template>
    </base-demo-flow>
</template>

<script>
import BaseDemoFlow from '@/components/demos/shared/base-demo-flow.vue';
import DemoStepManager from '@/mixins/demo-step-manager.js';
import NoIndexPage from '@/mixins/noindex-page.js';
import ExplainerInitialMessage from '@/components/demos/indirect-alcohol-promo/v2/explainer-initial-message.vue';
import ExplainerLandingPage from '@/components/demos/indirect-alcohol-promo/v2/explainer-landing-page.vue';
import MockTextConversation from '@/components/demos/shared/mock-text-conversation.vue';
import MockWineReleaseLanding from '@/components/demos/indirect-alcohol-promo/v2/mock-wine-release-landing.vue';

export default {
    name: 'DemoIndirectAlcoholPromoFlowV2',

    mixins: [DemoStepManager, NoIndexPage],

    components: {
        BaseDemoFlow,
        ExplainerInitialMessage,
        ExplainerLandingPage,
        MockTextConversation,
        MockWineReleaseLanding
    },

    data() {
        return {
            reservation_data: {},
            customer_data: {
                first_name: 'Sarah',
                last_name: 'Johnson',
                phone: '(555) 987-6543',
                member_since: '2021',
                club_tier: 'Reserve Club',
                shipping_address: {
                    street: '742 Vineyard Lane',
                    city: 'Napa',
                    state: 'CA',
                    zip: '94558'
                },
                card_on_file: {
                    brand: 'Visa',
                    last_four: '4949'
                }
            },
            wine_data: {
                name: '2024 Sauvignon Blanc',
                varietal: 'Sauvignon Blanc',
                vintage: '2024',
                regular_price: 45.99,
                club_price: 39.99,
                max_allocation: 6,
                tasting_notes: 'Bright citrus and tropical fruit notes with a crisp, refreshing finish.',
                release_type: 'Member Exclusive'
            }
        }
    },

    computed: {
        explainer_component() {
            switch (this.current_step) {
                case 'initial-text':
                    return 'ExplainerInitialMessage';
                case 'landing-page':
                    return 'ExplainerLandingPage';
                default:
                    return null;
            }
        },

        initial_message_text() {
            return `Hi ${this.customer_data.first_name}, this is the team at Barrel Creek Vineyards!\n\nWe have an exciting new release to share with you: {link}\n\nQuantities are limited and reserved for members only. If interested, please let us know asap and we'll hold them for you!\n\nText STOP to opt-out.`;
        },

        short_link() {
            return {
                url: '#',
                text: 'smsly.io/Bc7Kx',
                preventDefault: true,
                callback: this.handleGoToLandingPage
            };
        },

        conversation() {
            return [
                {
                    type: 'customer',
                    text: this.initial_message_text,
                    link: this.short_link,
                    time: '10:15 AM'
                }
            ];
        }
    },

    methods: {
        getStepConfig() {
            return {
                initial_step: 'initial-text',
                initial_phone_mode: 'messages',
                steps: ['initial-text', 'landing-page'],
                step_names: {
                    'initial-text': 'SMS Announcement',
                    'landing-page': 'Web Experience'
                },
                step_definitions: {
                    'initial-text': {
                        phone_mode: 'messages'
                    },
                    'landing-page': {
                        phone_mode: 'browser'
                    }
                }
            };
        },

        resetWebExperience() {
            this.phone_key++;
        },

        handleGoToLandingPage() {
            this.navigateToStep('landing-page');
        },

        handleChatComplete() {
            // no-op for demo
        },

        handleChatHandoff(data) {
            // no-op for demo
        }
    },

    mounted() {
        document.title = "Indirect Alcohol Promotion Demo | RedChirp";
        this.initializeSteps(this.getStepConfig());
    }
}
</script>

<style lang="scss" scoped></style>
